import React, { useState, useEffect } from 'react';
import domainModel from 'domain-model';
import { Button, Input, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { propTypes } from 'formsy-react';
import _ from 'lodash';
import withFormsyValidations from '../withFormsyValidations';

const regions = domainModel.customerSubUnit.getAllRegions();

const RegionSpecificsInput = ({
  value,
  setValue,
  errorMessage,
  disabled,
  onChange,
  isValid,
  name,
  supplier,
  customerSubUnit,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (supplier && supplier[name]) {
      setValue(supplier[name]);
      setIsExpanded(true);
    }
  }, [supplier]);

  const customerSubUnitRegion =
    domainModel.customerSubUnit.getRegion(customerSubUnit);
  const changeValue = event => {
    const parsedField = Number.parseInt(event.currentTarget.value, 10);
    const newFieldValue = _.isNaN(parsedField) ? null : parsedField;

    const newValue = {
      ...value,
      [event.currentTarget.name]: newFieldValue,
    };
    setValue(newValue);
    onChange(name, newValue);
  };

  return (
    <div className={` ${!isValid ? 'border border-danger' : ''}`}>
      {!isExpanded && (
        <Button
          onClick={() => {
            setIsExpanded(true);
          }}
        >
          Ange värde
        </Button>
      )}

      {isExpanded && (
        <Button
          onClick={() => {
            setIsExpanded(false);
            setValue(null);
            onChange(name, null);
          }}
        >
          Nollställ
        </Button>
      )}

      {isExpanded && (
        <>
          {regions
            .filter(region =>
              customerSubUnitRegion
                ? region.key === customerSubUnitRegion
                : true,
            )
            .map(region => (
              <Row>
                <Col>
                  {region.localizedName} ({region.zipStart}0 00 -{' '}
                  {region.zipEnd}9 99)
                  <Input
                    type="number"
                    disabled={disabled}
                    value={value == null ? '' : value[region.key]}
                    name={region.key}
                    onChange={changeValue}
                  />
                </Col>
              </Row>
            ))}
        </>
      )}
      <span>{errorMessage}</span>
    </div>
  );
};

RegionSpecificsInput.propTypes = {
  name: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  supplier: PropTypes.object,
  customerSubUnit: PropTypes.object,
  ...propTypes,
};

RegionSpecificsInput.defaultProps = {
  disabled: false,
  value: null,
};

export default withFormsyValidations(RegionSpecificsInput, () => ({
  numeric(values, value) {
    return _.every(value, val => /\d/.test(val));
  },
  positive(values, value) {
    return _.every(value, val => val >= 0);
  },
  elevenDigits(values, value) {
    if (!value) return true;
    const keys = Object.keys(value);
    return value && (keys.length === 11 || keys.length === 1);
  },
}));
